export default "__VITE_ASSET__UU9mrvYX__"